import * as framework from '../framework/export';
import * as common from '../common/export';
import * as router  from './router';
import * as init  from './init';

namespace MaApp {
    let ngModule: ng.IModule = angular.module('ma', [
        'ui.router',
        'ui.bootstrap',
        'pascalprecht.translate',
        'ngCookies',
        'ui.grid',
        'ui.grid.pagination',
        'ui.grid.resizeColumns',
        'ui.grid.selection',
        'ghiscoding.validation',
        'ui.sortable',
        'ui.sortable.multiselection',
        'ngFileUpload'
    ]);

    // 共通部品のクラスの登録処理の呼び出し
    common.init(ngModule);

    // 各業務のクラスの登録処理の呼び出し
    init.init(ngModule);

    // 画面遷移定義の呼び出し
    ngModule.config(config);
    ngModule.config(router.config);

    // 共通設定の呼び出し
    ngModule.config(common.config);

    ngModule.run(run);

    /* @ngInject */
    function config($urlRouterProvider: ng.ui.IUrlRouterProvider): void {
         // デフォルトURLルーティング設定
        $urlRouterProvider.otherwise('/');
    }

    /* @ngInject */
    function run($translate: ng.translate.ITranslateService): void {
        $translate.use('ja');
    }
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/app.ts
 **/